import { defineComponent } from "vue";
import { whenever } from "@vueuse/core";
import { N as NcFormBoxButton } from "./NcFormBoxButton-4xiKHRJH.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { u as useCopy } from "./useCopy-BWnr0WjK.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBoxCopyButton",
  props: {
    label: { default: void 0 },
    value: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["copy"],
  setup(__props, { emit }) {
    const props = __props;
    const { isCopied, copy, icon, altText } = useCopy(() => props.value);
    whenever(isCopied, () => emit("copy"));
    return { __sfc: true, props, emit, isCopied, copy, icon, altText, NcFormBoxButton, NcIconSvgWrapper };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcFormBoxButton, { attrs: { "disabled": _vm.disabled, "inverted-accent": "" }, on: { "click": _setup.copy }, scopedSlots: _vm._u([_vm.$slots.default || _vm.label ? { key: "default", fn: function() {
    return [_c("span", { staticClass: "hidden-visually" }, [_vm._v(" " + _vm._s(_setup.altText) + " ")]), _vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    })];
  }, proxy: true } : null, { key: "description", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.value) + " ")];
  }, proxy: true }, { key: "icon", fn: function() {
    return [_c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.icon, "inline": "" } })];
  }, proxy: true }], null, true) });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcFormBoxCopyButton = __component__.exports;
export {
  NcFormBoxCopyButton as N
};
//# sourceMappingURL=NcFormBoxCopyButton-AeYq9iKM.mjs.map
